module.exports = __webpack_public_path__ + "static/media/Android-amico.c0341421.svg";